import download from 'downloadjs';
import Modal from 'react-modal';
import { convertDateToAmericanFormat, getPermission, showMessageError, viewItem } from '../../../classes/functions';
import { useState, useEffect} from 'react';
import api from '../../../config.js';
import baseUrl from '../../../baseUrl.js';
import './tags.css';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import ReactTooltip from "react-tooltip";
import axios from 'axios';
import TablePagination from '../../../components/TablePagination';
import HeaderPage from '../../../components/BasePage/Header/index.js';
import { FaCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import InputDate from '../../../components/Inputs/Date/index.js';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '900px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function Users(){
  const [list, setList] = useState([]);  
  const [modalPrintTags, setModalPrintTags] = useState(false);
  const [carrying, setCarrying] = useState(true);

  //Paginação
  const [tipo, setTipo] = useState('');
  const [usada, setUsada] = useState('');
  const [impressa, setImpressa] = useState('');
  const [termSearch, setTermSearch] = useState('');
  const [de, setDe] = useState('');
  const [ate, setAte] = useState('');
  const [search_document, setSearchDocument] = useState('');
  const [search_product, setSearchProduct] = useState('');
  const [type_selection, setTypeSelection] = useState('');
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [codigo, setCodigo] = useState("");
  const [filters, setFilters] = useState({
    data: ""
  })
    
  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }

  let delay;
  function getTags() {
    setTermSearch(termSearch);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {      
      let dados = {
        data: {
          termSearch: termSearch,
          tipo: tipo,
          usada: usada,
          impressa: impressa,
          document: search_document,
          product: search_product,
          codigo: codigo,
          data: filters.data,
          page: page,
          qtdePage: qtdePage,
        }
      };
  
      api.post("/api/tags/getSearch", dados)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, qtdePage);
      
          setCarrying(false);
        }
      ).catch((error) => {
        toast.error('Ops! Ocorreu um erro.');
        setCarrying(false);
      });
    }, 750);
  }
  
  function print () {
    if (type_selection == 'S') {
      printSearch();
    } else if (type_selection == 'I') {
      printInterval();
    }
  }
  
  function printSearch () {
    setCarrying(true);
    let data = {
      data: {
        tipo: tipo,
        usada: usada,
        impressa: impressa,
        termSearch: termSearch,
        document: search_document,
        product: search_product,
        codigo: codigo,
        data: filters.data,
      }
    };

    api.post("/api/tags/getSearch", data)
    .then((response) => {
      axios.post(
        baseUrl + "api/tags/printList", response.data.dados,
        {
          responseType: 'blob',
          headers: {
            empresa: localStorage.empresa,
            usuario: localStorage.usuario
          }
        }
  
      ).then((response) => {
        const content = response.headers['content-type'];
        download(response.data, 'etiquetas.pdf', content);
        getTags();
        setCarrying(false);
      }).catch((error) => {
        console.log(error)
        showMessageError(error.response.data);
        setCarrying(false);
      });
      
    }).catch((error) => {
      toast.error('Ops! Ocorreu um erro.');
      setCarrying(false);
    });
    
  }
  
  function printInterval () {
    setCarrying(true);
    axios.get(
      baseUrl + "api/tags/printInterval?de=" + de + "&ate=" + ate, 
      {responseType: 'blob',
      headers: {
        empresa: localStorage.empresa,
        usuario: localStorage.usuario
      }} 
    ).then((response) => {
      const content = response.headers['content-type'];
      download(response.data, 'etiquetas.pdf', content);
      getTags();
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function closeModal () {
    setModalPrintTags(false);
  }
  
  function openModalPrint () {
    setDe('');
    setAte('');
    setTypeSelection('S');
    setModalPrintTags(true);
  }
  
  useEffect(() => {
    getTags();
  }, [qtdePage, page, termSearch, tipo, usada, impressa, search_document, search_product, codigo, filters.data]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <HeaderPage title="Etiquetas" URL="/tags/cadastrar" itensByPage={qtdePage} setItensByPage={setQtdePage} search={termSearch} setSearch={setTermSearch} isNotEditable>
          {getPermission('OPERACOES - ETIQUETAS - CADASTRO') && <Link to="/tags/cadastrar">
            <button className="buttonInsert">
              Gerar Avulsa
            </button> 
          </Link>}
          {getPermission('OPERACOES - ETIQUETAS - IMPRESSAO') && <button className="buttonInsert" style={{marginRight: "0.6rem"}} onClick={openModalPrint}>
            Imprimir
          </button>}
        </HeaderPage>
        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">
                  <div className="formDiv">
                    Etiqueta  <br /><br />
                    <input type="text" placeholder="Código" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    Tipo  <br /><br />
                    <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
                      <option value="">Todos</option>
                      <option value="P">Palete</option>
                    </select>
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    Status  <br /><br />
                    <select value={usada} onChange={(e) => setUsada(e.target.value)}>
                      <option value="">Todos</option>
                      <option value="N">Disponível</option>
                      <option value="S">Não Disponível</option>
                      <option value="I">Não Utilizada</option>
                    </select>
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    Impressa  <br /><br />
                    <select value={impressa} onChange={(e) => setImpressa(e.target.value)}>
                      <option value="">Todos</option>
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    Documento  <br /><br />
                    <input type="text" placeholder="Documento" value={search_document} onChange={ (e) => setSearchDocument(e.target.value) }/>
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    Produto  <br /><br />
                    <input type="text" placeholder="Produto" value={search_product} onChange={ (e) => setSearchProduct(e.target.value) }/>
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    Data  <br /><br />
                    <InputDate filters={filters} setFilters={setFilters} propertyFilter="data" />
                  </div>
                </th>
                <th scope="col">Hora</th>
                <th scope="col">Gerada por</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Código">{item.codigo}</td>
                    <td data-label="Tipo">{viewItem([{id: 'P', descricao: 'Palete'}], item.tipo)}</td>
                    <td data-label="Usada">{viewItem([{id: 'S', descricao: 'Utilizada'},{id: 'N', descricao: 'Disponível'},{id: 'I', descricao: 'Não Utilizada'}], item.usada)}</td>
                    <td data-label="Impressa">{viewItem([{id: 'S', descricao: 'Sim'},{id: 'N', descricao: 'Não'}], item.impressa)}</td>
                    <td data-label="Documento">{item.documento}</td>
                    <td data-label="Produto">{item.produto}</td>
                    <td data-label="Data">{item.data}</td>
                    <td data-label="Hora">{item.hora}</td>
                    <td data-label="Usuário">{item.usuario}</td>
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                  <td colSpan={9}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <br/>
        <TablePagination limitPage={limitPage} setLimitPage={setLimitPage} page={page} qtdePage={qtdePage} setCarrying={setCarrying} setList={setList} setPage={setPage} setQtdePage={setQtdePage} setTotal={setTotal} termSearch={termSearch} API="/api/tags/getSearch" params={{tipo: tipo, usada: usada, impressa: impressa, document: search_document, product: search_product, codigo: codigo, data: filters.data}}/>
      </div>}

      <Modal  
        isOpen={modalPrintTags}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Tags"
        ariaHideApp={false}
      >
        <div className="body-modal">
          <div className="formDiv">
            <div className="divGroup">
              <div className="formDiv">
                <label>Selecione o tipo de impressão: </label><br/>
                <select value={type_selection} onChange={ (e) => setTypeSelection(e.target.value) }>
                  <option value="S">Imprimir Pesquisa</option>
                  <option value="I">Imprimir Intervalo</option>
                </select>
              </div>
            </div>

            {type_selection == 'I' && <div className="divGroup">
              <div className="formDiv">
                <label>De</label><br/>
                <input type="text" placeholder="" value={de} onChange={ (e) => setDe(e.target.value) }/>
              </div>

              <div className="formDiv">
                <label>Até</label><br/>
                <input type="text" placeholder="" value={ate} onChange={ (e) => setAte(e.target.value) }/>
              </div>
            </div>}
          </div>
          <div className="formDiv">
            <button type="button" className="buttonSubmit" onClick={print}>Imprimir</button>
            <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}